import { Widgets } from "../../types/widgets";

const widgets: Widgets = {
  addressAutocomplete: {
    prompt: "Enter asset address",
  },
  firstTimeLogin: {
    title: "Customer Notification",
    warning: "Please be advised that the Climate Risk Hub is undergoing continuous refinement and improvement.",
    body: `<p>We regularly update the XDI Hub to provide the best available climate risk insights.
    This includes improvements to platform features and functionality, as well as periodic updates
    to our underlying climate risk models and datasets to reflect the latest available science and data.</p>

    <p>We value your feedback. If you notice something unexpected or have suggestions for improving
    the XDI Hub, please <a>get in touch with us</a>.</p>`,
    button: "I Understand",
  },
  versionUpdate: {
    title: "Update Notification",
    body: `<p>Based on the platform's current version number, it seems certain
    updates have been made since your last login. For more information on the
    most recent changes, please visit the <b>platform's changelog</b>.</p>

    <p>If you have any questions or feedback regarding these updates,
    please <a>contact customer support</a>.</p>`,
    button: "I Understand",
  },
  map: {
    hints: {
      click: "Hint: Click map to move the pin if the search result is not accurate.",
    },
  },
  notifications: {
    title: "Notifications",
    hints: {
      empty: "No new notifications.",
    },
  },
  textInput: {
    addresses: {
      countOverLimit: "Too many addresses entered ({{count}}/{{max}}).",
      countWithinLimit: "{{count}}/{{max}} addresses entered.",
      placeholder:
        "Enter coordinates or street-level addresses in the format specified by local post authority here: \n123 Street Name, City Name, Country",
    },
  },
  upload: {
    csv: {
      hints: {
        first10Lines: "Note: Only the first 10 lines of this file will be used.",
      },
      prompt: "Upload data via .csv file",
    },
    om: {
      prompt: "Select .csv file containing OMs",
    },
  },
  outputs: {
    riskiest: {
      title: "Riskiest Point Results - .csv, .xlsx",
      description: `Riskiest Point output includes comprehensive physical risk results for the single point with the highest
                  MVAR% based on user defined criteria. Understanding of the riskiest point is useful for due diligence &
                  stress testing.`,
    },
    screen: {
      title: "Simple Risk Ratings Results - .csv",
      mode: "baseline",
      description: `Simple Risk Ratings output presents a streamlined risk classification for each location within the analysis at
                  5-yearly time intervals.`,
      descriptionLargeSite: `Simple Risk Ratings output presents a streamlined risk classification for each location, assessed across six
                  future time intervals. It is designed for compatibility with outputs from Single Asset Screen and Quick
                  Batch Screen tools and is ideal for high-level comparison or board-level summaries.`,
    },
    small: {
      title: "Direct Risk Results - .csv, .xlsx",
      mode: "baseline",
      description: `Direct Risk output is a customised dataset showing the estimated damage and loss for each point using the Baseline input settings provided at the time of upload. You can choose which asset risk metrics to include, making this output suitable for tailored reporting, analysis, or integration into internal workflows.`,
    },
    exposures: {
      title: "Flood Exposure Results - .csv",
      mode: "baseline",
      description: `Flood Exposure output offers a simple binary indication of whether a given location is situated within a flood-prone area (riverine or surface water) in the present day under specific return periods. This output does not include information around risk severity (flood depth), or damage or loss projections. It is best used as an indicator of exposure only.`,
    },
    tall: {
      title: "Comprehensive Results Library - .zip",
      description: `A Comprehensive Results Library is a programmatically structured dataset containing all available risk
              metrics used in your physical risk assessments. It is best suited for advanced users and supports custom
              visualisations, deeper modelling, or integration into technical pipelines`,
    },
    smallResilience: {
      title: "Automated Resilience Results - .csv, .xlsx",
      mode: "automatedResilience",
      description:
        "Auto Resilience output simulates damage and loss for each point under a range of automatically generated resilience pathways. It simulates how each asset's physical climate risk outcomes are expected to change under different resilience assumptions, making it suitable for resilience planning, reporting, and strategic decision-making.",
    },
  },
};

export default widgets;
